/* Hearsay v6.12 conversion layer. Loaded after hearsay.js and leaves it untouched.
   1. Phones: the sticky bar also shows while the main Add to bag button is still below the screen.
      In that state its button reads "Choose your jars" and scrolls to the bundle picker.
   2. Buy-box-only layout (ad landing page): the sticky label keeps the product name.
   3. Ad landing page: the ad angle the visitor came from is saved on the bag as "Ad angle",
      so it shows on the order in admin. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncHtmlClass(bar) {
    var on = bar.classList.contains('is-on') || bar.classList.contains('is-pre');
    document.documentElement.classList.toggle('has-sticky-atc', on);
  }

  function initEarlySticky() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;
    new MutationObserver(function () { syncHtmlClass(bar); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    var mainBtn = $('[data-product-page] [data-add-button]');
    if (!bar.hasAttribute('data-sticky-early') || !mainBtn || !('IntersectionObserver' in window) || !window.matchMedia) return;
    var mq = matchMedia('(max-width: 600px)');
    var btn = bar.querySelector('[data-sticky-add]');
    if (!btn) return;
    var addLabel = btn.textContent;
    var chooseLabel = bar.getAttribute('data-choose-label') || '';
    var below = false;

    function apply() {
      var pre = below && mq.matches;
      bar.classList.toggle('is-pre', pre);
      if (pre) {
        bar.setAttribute('aria-hidden', 'false');
        btn.tabIndex = 0;
      } else if (!bar.classList.contains('is-on')) {
        bar.setAttribute('aria-hidden', 'true');
        btn.tabIndex = -1;
      }
      if (chooseLabel) btn.textContent = pre ? chooseLabel : addLabel;
    }

    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      below = !e.isIntersecting && e.boundingClientRect.top > 0;
      apply();
    }).observe(mainBtn);
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);

    // Before the picker is reached, the bar's button scrolls to it instead of adding to the bag.
    // Capture on document so hearsay.js's own click handler on the button never runs in this state.
    document.addEventListener('click', function (e) {
      if (!bar.classList.contains('is-pre') || !e.target.closest('[data-sticky-add]')) return;
      e.preventDefault();
      e.stopPropagation();
      var picker = $('[data-product-page] [data-bundles]') || mainBtn;
      picker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var checked = picker.querySelector('input:checked');
      if (checked) setTimeout(function () { try { checked.focus({ preventScroll: true }); } catch (err) {} }, reduce ? 0 : 450);
    }, true);
  }

  function initStickyTitle() {
    var bar = $('[data-sticky-atc]');
    var page = $('[data-product-page]');
    if (!bar || !page || $('h1', page)) return;
    var label = bar.querySelector('[data-sticky-label]');
    var title = (bar.getAttribute('data-product-title') || '').trim();
    if (!label || !title) return;
    var prefix = title + ' · ';
    function fix() { var t = label.textContent.trim(); if (t && t.indexOf(prefix) !== 0) label.textContent = prefix + t; }
    new MutationObserver(fix).observe(label, { childList: true, characterData: true, subtree: true });
    fix();
  }

  function initAngleTag() {
    var angle = '';
    try { angle = sessionStorage.getItem('hs-angle') || ''; } catch (e) { return; }
    if (!angle) return;
    var drawer = document.getElementById('CartDrawer');
    var H = window.Hearsay || {};
    var url = ((H.routes && H.routes.root) || '/').replace(/\/?$/, '/') + 'cart/update.js';
    function send() {
      var sent = '';
      try { sent = sessionStorage.getItem('hs-angle-sent') || ''; } catch (e) {}
      if (sent === angle) return;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Ad angle': angle } })
      }).then(function (r) {
        if (r.ok) { try { sessionStorage.setItem('hs-angle-sent', angle); } catch (e) {} }
      }).catch(function () {});
    }
    // Only after something is in the bag (the drawer opens after an add), so this never races the add itself.
    if (drawer) {
      new MutationObserver(function () { if (drawer.classList.contains('is-on')) send(); })
        .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    initEarlySticky();
    initStickyTitle();
    initAngleTag();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
